import Helper from '../util/Helper';

export default {
    init() {
        var $body = $('body'),
            $navbarPrimary = $('#navbarPrimary'),
            $dropdownToggle = $navbarPrimary.find('.nav-item.dropdown'),
            classOpen = 'open',
            $headerNavWrapper = $('header nav.navbar').first(),
            fixedOffset = $headerNavWrapper.offset().top + 6, // + 6 content before position
            fixedClass = 'fixed',
            $toTop = $('.scroll-to-top').first(),
            screenLg = 1120,
            headerUsps = $('.header-usps');

        if (headerUsps.length) {
            var headerUspsSlider = {
                dots: false,
                infinite: true,
                autoplay: true,
                autoplaySpeed: 5000,
                arrows: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: false,
                cssEase: 'linear',
                mobileFirst: true,
                responsive: [
                    {
                        breakpoint: 1000,
                        settings: 'unslick',
                    },
                    {
                        breakpoint: 700,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1,
                        },
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                        },
                    },
                ],
            };

            /*
             * defer initialization until it is really needed: slider should only be shown for screens
             * smaller than 1000
             */
            if ($(window).width() < 1000) {
                headerUsps.slick(headerUspsSlider);
            } else {
                $(window).resize(function () {
                    if ($(window).width() < 1000 && !headerUsps.hasClass('slick-initialized')) {
                        headerUsps.slick(headerUspsSlider);
                    }
                });
            }
        }

        $('[data-toggle="offcanvas"]').on('click', function () {
            $('body').toggleClass('in');
            $('.offcanvas-collapse').toggleClass(classOpen);
            $('.navbar-toggler').toggleClass('is-open');
        });

        $('.toggle-submenu').on('click', function (e) {
            e.preventDefault();
            var $dropdownItem = $(this).parents('.nav-item.dropdown');
            if (!$dropdownItem.hasClass(classOpen)) {
                $dropdownItem.addClass(classOpen);
                $dropdownItem.find('.dropdown-menu').first().stop(true, true).slideDown(200);
            } else {
                $dropdownItem.removeClass(classOpen);
                $dropdownItem.find('.dropdown-menu').first().stop(true, true).slideUp(200);
            }
        });

        $(document).on('scroll', function () {
            let scrollPosition = $(window).scrollTop()

            // store threshold for later use
            if (typeof window.stickyThreshold === 'undefined') {
                window.stickyThreshold = fixedOffset;
            }
            if (scrollPosition > window.stickyThreshold) {
                $body.addClass(fixedClass);
            } else {
                $body.removeClass(fixedClass);
            }
            return;
        });

        $(document).on('scroll', function () {
            var scrollPosition = $(window).scrollTop(), fadePosition = 200;

            if (scrollPosition > fadePosition) {
                $toTop.fadeIn();
                return;
            }
            if (scrollPosition < fadePosition) {
                $toTop.fadeOut();
                return;
            }
        });

        if (!Helper.smallScreenHelper(screenLg)) {
            $dropdownToggle.mouseenter(function (e) {
                e.stopPropagation();
                $(this).addClass(classOpen);
                $(this).find('.dropdown-menu').first().stop(true, true).slideDown(200);
            });
            $dropdownToggle.mouseleave(function () {
                $(this).removeClass(classOpen);
                $(this).find('.dropdown-menu').first().stop(true, true).slideUp(200);
            });
        }

        $toTop.click(function (e) {
            e.preventDefault();
            var $target = $('html, body');
            Helper.smoothScroll($target, 0);
            return false;
        });

        $('.accordion-item .accordion-content').hide().removeClass('loading');
        $('.accordion-item .accordion-title').on('click', function (e) {
            e.preventDefault();
            $(this).parent('div').toggleClass('open');
            $(this).next('.accordion-content').slideToggle(500);
        });

    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js